import { styled, theme } from "@theme/stitches.config"

export const HeroWrapper = styled("div", {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(100vh - 150px)",
    py: 166,
    "@mdDown": {
        px: 10,
        minHeight: "calc(100vh - 120px)"
    }
})

export const Overlay = styled("div", {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%)",
    zIndex: 1
})

export const BackgroundImageWrapper = styled("div", {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    "& img, & .gatsby-image-wrapper, * .gatsby-image-wrapper img": {
        width: "100%",
        height: "100%",
        objectPosition: "top",
        objectFit: "cover"
    }
})

export const ContentWrapper = styled("div", {
    zIndex: 1,
    textAlign: "center",
    overflow: "hidden",
    py: 20
})

export const Subtitle = styled("h2", {
    color: theme.colors.white,
    fontSize: theme.fontSizes.desktopH5,
    lineHeight: 1.1875,
    "@mdDown": {
        fontSize: theme.fontSizes.mobileH5
    }
})

export const Title = styled("h1", {
    color: "transparent",
    WebkitTextStroke: `3px ${theme.colors.R500}`,
    fontSizePxToRem: 100,
    "@mdDown": {
        fontSizePxToRem: 50
    },
    "@xsDown": {
        fontSizePxToRem: 40
    }
})

export const Description = styled("div", {
    mt: 45,
    maxWidth: 650,
    fontSize: theme.fontSizes.desktopLarge,
    "@mdDown": {
        mt: 20,
        fontSize: theme.fontSizes.desktopLarge
    }
})

export const ButtonWrapper = styled("div", {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    margin: "36px 0 0",
    "@mdDown": {
        justifyContent: "space-between"
    },
    "& > button, & > a": {
        "@mdDown": {
            width: "100%",
            mx: 20
        }
    },
    "& button:not(:last-child), & a:not(:last-child)": {
        mr: 40,
        "@mdDown": {
            mr: 20,
            mb: 20
        }
    }
})

export const ViewMore = styled("a", {
    position: "absolute",
    left: "50%",
    cursor: "pointer",
    bottom: 46,
    transform: "translateX(-50%)",
    fontSize: theme.fontSizes.desktopH6,
    fontFamily: theme.fonts.heading,
    textTransform: "uppercase",
    mb: 47,
    zIndex: 1,
    "@mdDown": {
        mb: 10,
        display: "none"
    }
})

export const ViewMoreArrow = styled("img", {
    position: "absolute",
    left: "50%",
    bottom: 0,
    zIndex: 10,
    transform: "translate(-50%, 50%)",
    "@mdDown": {
        display: "none"
    }
})
